import store from '@/store'
/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  return str.length > 0
}

export function validatePass2() {
  return (rule, value, callback) => {
    const passLength = value.trim().length
    if (value === '') {
      callback(new Error('Please enter your password'))
    } else if (passLength < 6 || passLength > 20) {
      callback(new Error('Your password must be 6-20 characters long'))
    } else {
      if (this.pwdForm.checkPass !== '') {
        this.$refs.pwdForm.validateField('checkPass')
      }
      callback()
    }
  }
}

export function validateMobile() {
  return /(09)\d{9}$/
}

function formatHumanAmount(amount) {
  if (amount >= 1e9) {
    return (amount / 1e9) + ' billion';
  } else if (amount >= 1e6) {
    return (amount / 1e6) + ' million';
  }
  return amount;
}

export function validateFormAmount({
  value,
  callback,
  rule,
  isMaxLimit = true,
  maxAmount = 10000000000,
  moreCountryMaxLimit = [],
  countryCode
}) {
  const country_code = countryCode || (store.getters.curCountry && store.getters.curCountry.country_code)
  // 不同国家特殊处理
  if (Array.isArray(moreCountryMaxLimit) && moreCountryMaxLimit.length > 0) {
    for (const item of moreCountryMaxLimit) {
      if (
        typeof item === "object" &&
        typeof item.countryCode === "string" &&
        typeof item.countryMaxAmount === "number"&&
        country_code === item.countryCode
      ) {
        if (value > item.countryMaxAmount) {
          return callback(new Error(`Currently up to ${formatHumanAmount(item.countryMaxAmount)}`));
        }
      }
    }
  }
  // 一般通用限制
  if (isMaxLimit && value > maxAmount) {
    return callback(new Error(`Currently up to ${formatHumanAmount(maxAmount)}`));
  }

  if (value <= 0 || isNaN(value)) {
    return callback(new Error('Please enter a non-negative number'));
  }

  if (['ID', 'VN'].includes(country_code)) {
    if (!/^[0-9]+$/.test(value) || String(value).includes('.')) {
      return callback(new Error('Please enter an integer amount, only integers are supported'));
    }
  }

  if (!/^(0|[1-9]\d*)(.\d{1,2})?$/.test(value)) {
    return callback(new Error('Please enter two decimal places'));
  }
}

